export const STORE_DATA_REVALIDATE = parseInt(process.env.STORE_DATA_REVALIDATE, 10) || 600;
